// @ts-nocheck
/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Description of a grading dimension applicability for a task analysis
 */
export interface GradingDimensionDescription {
  /** indicates whether the dimension is applicable to the task */
  applicable: boolean;
  /** list of subtasks or demands of the task that fall under this dimension */
  demands: string[];
}
